<template>
  <va-card :title="$t('menu.lists') + ' ' + $t('tables.loads.code') + ' ' + this.$route.params.loadCode">
    <va-button
      v-if="this.$route.params.assemblyLine == 9"
      small
      inline
      color="#ff842b"
      icon="fa fa-chevron-left"
      class="ma-0"
      :to="{ name: 'loads', params: { back: this.$route.params.loadId, code: this.$route.params.load, assemblyLine: this.$route.params.assemblyLine } }"
    >
      {{ $t('menu.back') }}
    </va-button>
    <va-button
      v-if="this.$route.params.assemblyLine == 10"
      small
      inline
      color="#ff842b"
      icon="fa fa-chevron-left"
      class="ma-0"
      :to="{ name: 'load_palletizing', params: { back: this.$route.params.loadId, code: this.$route.params.load, assemblyLine: this.$route.params.assemblyLine } }"
    >
      {{ $t('menu.back') }}
    </va-button>

    <va-button
      v-if="this.$route.params.assemblyLine == 12"
      small
      inline
      color="#ff842b"
      icon="fa fa-chevron-left"
      class="ma-0"
      :to="{ name: 'loads_finished', params: { back: this.$route.params.loadId, code: this.$route.params.load, assemblyLine: this.$route.params.assemblyLine } }"
    >
      {{ $t('menu.back') }}
    </va-button>
    <div class="row">
      <div class="flex xs12">
        <va-button
          v-if="this.$route.params.assemblyLine == 11"
          small
          inline
          color="#ff842b"
          icon="fa fa-chevron-left"
          class="ma-0"
          :to="{ name: 'load_sequence', params: { back: this.$route.params.loadId, code: this.$route.params.load, assemblyLine: this.$route.params.assemblyLine } }"
        >
          {{ $t('menu.back') }}
        </va-button>
      </div>
    </div>

    <div v-show="loading" class="text--center pb-4">
      <div class="flex-center spinner-box">
        <slot name="loading">
          <spring-spinner
            slot="loading"
            :animation-duration="currentDuration"
            :is="spload.name"
            :color="spinnersColor"
            :size="config.size"
          />
        </slot>
      </div>
    </div>

    <va-data-table
      :fields="fields"
      :data="data"
      :per-page="20"
      v-show="!loading"
      no-pagination
    >

    <template slot="status" slot-scope="props">
      <va-badge v-if="props.rowData.returned == true" color="orangeRed" class="ma-0">
        {{ $t('tables.orders.returned') }}
      </va-badge>

      <va-badge v-if="props.rowData.quarantine" color="danger" class="ma-0">
        {{ $t('menu.quarantine') }}
      </va-badge>
    </template>

      <template slot="actions" slot-scope="props">

        <va-button v-if="props.rowData.order_errors.length > 0"
          small
          inline
          color="danger"
          icon="fa fa-list-alt"
          class="ma-1"
          :to="{ name: 'order-errors', params: { orderId: props.rowData.id, loadId: loadId, code: props.rowData.code, loadCode: $route.params.loadCode, assemblyLine: assemblyLine, load: load } }"
        >
          {{ $t('menu.order_error') }}
        </va-button>

        <va-button
          small
          inline
          color="dark"
          icon="fa fa-list-alt"
          class="ma-0"
          :to="{ name: 'list-order-products',params: { orderId: props.rowData.id, loadId: loadId, code: props.rowData.code, loadCode: $route.params.loadCode, assemblyLine: assemblyLine, load: load } }"
        >
          {{ $t('menu.products') }}
        </va-button>
        <va-button
          small
          inline
          color="greenLight"
          icon="fa fa-list-alt"
          class="ma-1"
          :to="{ name: 'list-sorted-order-products', params: { orderId: props.rowData.id, assemblyLine: assemblyLine, loadId: loadId, code: props.rowData.code, loadCode: $route.params.loadCode, load: load} }"
        >
          {{ $t('menu.order_products') }}
        </va-button>
        <va-button
          small
          inline
          color="green"
          icon="fa fa-list-alt"
          class="ma-1"
          :to="{ name: 'list-order-histories', params: { orderId: props.rowData.id, assemblyLine: assemblyLine, loadId: loadId, code: props.rowData.code, loadCode: $route.params.loadCode, load: load } }"
        >
          {{ $t('menu.order_history') }}
        </va-button>
      </template>
    </va-data-table>
  </va-card>
</template>

<script>
import LoadAPI from '@/services/LoadAPI'
import { mapState } from "vuex";
import * as spinners from 'epic-spinners'
import axios from 'axios'

export default {
  components: {
    ...spinners,
    },
  data () {
    return {
      data: [],
      load: '',
      loading: false,
      assemblyLine: this.$route.params.assemblyLine,
      selected_import: '',
      config: {
        size: 80,
        group: 4,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      showModalRemove: false,
    }
  },

  channels: {
    NeedRefreshOrders: {
      received(data) {
        this.getAllOrdersByLoad();
      },
    }
  },

  mounted () {
    this.$cable.subscribe({ channel: 'NeedRefreshOrders', company: this.currentUser.company })
    this.getAllOrdersByLoad();
  },
  methods: {
    getAllOrdersByLoad() {
      this.loadId = this.$route.params.loadID
      this.load = this.$route.params.code
      this.loading = true

      if (this.$route.params.back) {
        this.loadId = this.$route.params.back
      } else {
        this.loadId = this.$route.params.loadID
      }

      LoadAPI.getOrdersByLoad(this.loadId).then(response => {
        this.data = response.data.load.orders
        this.loading = false

        this.data.map(res => {
          if (res.refused == false) {
            res.refused_flg = this.$t('flags.false')
          } else {
            res.refused_flg = this.$t('flags.true')
          }
          if (res.assembled == false) {
            res.assembled = this.$t('flags.false')
          } else {
            res.assembled = this.$t('flags.true')
          }
          if (res.checked == false) {
            res.checked = this.$t('flags.false')
          } else {
            res.checked = this.$t('flags.true')
          }
          if (res.loaded == false) {
            res.loaded = this.$t('flags.false')
          } else {
            res.loaded = this.$t('flags.true')
          }
        })
      })
    }
  },
  computed: {
    ...mapState(['currentUser']),

    fields () {
      return [
        {
          name: '__slot:status',
          title: this.$t('tables.orders.status'),
          width: '5%',
        },
        {
          name: 'assembly_sequence',
          title: this.$t('tables.orders.assembly_sequence'),
          width: '5%',
        },
        {
          name: 'token',
          title: this.$t('tables.orders.token'),
          width: '5%',
        },
        {
          name: 'user',
          title: this.$t('tables.orders.user'),
          width: '10%',
        },
        {
          name: 'code',
          title: this.$t('tables.orders.code'),
          width: '5%',
        },
        {
          name: 'vehicle',
          title: this.$t('tables.orders.vehicle'),
          width: '5%',
        },
        {
          name: 'order_step',
          title: this.$t('forms.selects.step'),
          width: '5%',
        },
        {
          name: 'assembled',
          title: this.$t('tables.orders.assembled'),
          width: '5%',
        },
        {
          name: 'checked',
          title: this.$t('tables.orders.checked'),
          width: '5%',
        },
        {
          name: 'loaded',
          title: this.$t('tables.orders.loaded'),
          width: '5%',
        },
        {
          name: 'boxes_quantity',
          title: this.$t('tables.load_orders.boxes_quantity'),
          width: '5%',
          dataClass: 'text-center',
        },
        {
          name: 'weight',
          title: this.$t('tables.load_orders.weight'),
          width: '5%',
          dataClass: 'text-center',
        },
        {
          name: 'delivery_date',
          title: this.$t('tables.orders.delivery_date'),
          width: '10%',
        },
        {
          name: 'pallet_type',
          title: this.$t('tables.load_orders.pallet_type'),
          width: '10%',
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
        }]
      },
      spload () {
      return spinners.ScalingSquaresSpinner
    }
  },
}
</script>
